import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { actualitiesLink, directLink } from '../constants/endspoints'
import { playerLink } from '../constants/links'
import Image from '../components/Image'
import { logoVertical, placeholderImg } from '../constants/files'
import { useQuery } from '@tanstack/react-query'
import { fetchArticles } from '../api/article'
import ActuCardPlaceholder from '../components/ActuCardPlaceholder'
import IsEmpty from '../components/IsEmpty'
import ActuCard from '../components/ActuCard'
import { getFirstImageSrc, getTextFromHTML } from '../constants/functions'

import computer from '../assets/icons/computer.png'
import phone from '../assets/icons/phone.png'
import tablet from '../assets/icons/tablet.png'
import tv from '../assets/icons/tv.png'
import { getYear } from 'date-fns'


const Home = () => {



    // ######## GET ARTICLES ########

    // 1. Fetch All actualities
    const { data: actualitiesData, status } = useQuery({
        queryKey: ["actualities", {page: 1}],
        queryFn: () => fetchArticles({'order[id]':"desc", page: 1, status: true}),
    });


    // 2. store actualities in a state
    const [data, setData] = useState([]);
    useEffect(() => {
        if(actualitiesData?.data?.member?.length > 0){
            setData(
                actualitiesData?.data?.member
                .slice(0, 2)
            );
        }else{
            setData([]);
        }
    }, [actualitiesData]);



    return (
        <div className='text-white mb-md-3 mb-5 d-flex flex-column h-100' >
            <div className='container-fluid'>
                <div className='d-flex justify-content-around mt-lg-2'>
                    {/* lateral img */}
                    <div className='col-lg-auto align-items-stretch'>
                        <div className='d-md-flex flex-column d-none justify-content-between align-items-strech h-100 pe-2'>
                            {/* Imgs up */}
                            <div>
                                <Image alt={'UBIZNEWS OM5'} src={logoVertical} className='object-fit-contain mb-2 text-center' style={{width:'auto', height:'9rem'}} />
                                <div className='d-flex flex-column justify-content-between align-items-center mb-2'>
                                    <img src={phone} alt='phone' style={{height:"2rem",}} className='object-fit-contain mb-2'/>
                                    <img src={tablet} alt='tablet' style={{height:"2rem",}} className='object-fit-contain mb-2'/>
                                    <img src={computer} alt='computer' style={{height:"1.76rem",}} className='object-fit-contain mb-2'/>
                                    <img src={tv} alt='tv' style={{height:"1.7rem",}} className='object-fit-contain mb-2'/>
                                </div>
                            </div>
                            
                            {/* Btn down */}
                            <div>
                                <NavLink 
                                    to={directLink}
                                    reloadDocument
                                    className='d-flex justify-content-center align-items-center text-black fs-6 px-2 py-1 mb-2 bg-black border border-1 border-white' 
                                    >
                                    <i className='fa-regular fa-bell text-white me-2'></i>
                                    <span className='text-white fs-9s fw-bold'>Voir +</span>
                                </NavLink>
                                <div id='language-switcher' className='d-none d-md-flex flex-row justify-content-start mb-md-0 mb-4 menu'></div>
                            </div>
                        </div>
                    </div>

                    {/* Player */}
                    <div className='col align-items-stretch'>
                        <div className='object-fit-cover'>
                            <iframe src={playerLink}
                                style={{overflow:"hidden", border:"none", aspectRatio:"1.77777"}}
                                allowFullScreen={true}
                                className='player-size bgcolor-secondary-25'
                                title="UBIZNEWS en Direct"
                                allow="web-share">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>


            {/* Some actualities */}
            <div className='container-fluid mt-4 d-md-none d-block'>
                <h4 className='fs-3 text-nowrap fw-bold me-md-0 me-2'>Actualités</h4>
                <hr className='mt-0 mb-1 border-white'/>
                <div className='mb-3 row justify-content-start align-items-start'>
                    {
                        (status === "pending")?
                        [1,2,3,4].map((item, index) => (
                            <div key={index} className='col-lg-3 col-md-4 col-sm-6 mt-3'>
                                <ActuCardPlaceholder/>
                            </div>
                        ))
                        :status === "error"?
                            <IsEmpty icon={"fa-light fa-exclamation-circle mb-2"} message={"Une erreur c'est produite"} />
                        :data?.length <= 0 ?
                            <IsEmpty icon={"fa-light fa-newspaper"} message={"Aucune actualité enregistrée "} />
                        :data?.map((actuality, index) => {
                            return (
                                <div key={index} className='col-lg-3 col-md-4 col-sm-6 mt-3'>
                                    <ActuCard 
                                        image={getFirstImageSrc(actuality?.content)? getFirstImageSrc(actuality?.content) : placeholderImg }
                                        title={actuality?.title}
                                        category={actuality?.Category?.name}
                                        description={getTextFromHTML(actuality?.content)}
                                        link={`${actualitiesLink}/${actuality?.id}`}
                                        date={actuality?.createdAt}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
                <div className='mt-3 w-100 d-flex justify-content-end'>
                    <NavLink to={actualitiesLink} className='border bordercolor-primary rounded-0 w-auto d-flex align-items-center text-white px-2 py-1'>
                        <span className='fs-9s me-2'>Voir plus</span>
                        <fa className='fa-regular fa-angle-right'></fa>
                    </NavLink>
                </div>
            </div>


            {/* Footer */}
            <div className=' py-2 mt-auto container-fluid'>
                <div className='bgcolor-hero-actuality mt-3' style={{height:'4rem'}}>
                    <div className=' h-100'>
                        <div className='w-100 h-100 pb-1 d-flex justify-content-center align-items-end fs-7s text-white fw-medium text-center text-opacity-75'>
                            Tous droits de reproduction et de diffusion réservés © {getYear(Date.now())} UBIZNEWS
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home